import { Component, Inject, OnInit, NgZone, DestroyRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'nphs-user-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmDialogComponent implements OnInit {
  title: string = '';
  message: string = '';
  isCancelNo: string = '';
  viewAlert: string = '';
  yesContinue: string = '';
  isConfirm: string = '';
  displayNo: string = '';
  isYesNo: string = '';
  showOrderView: string = '';
  isOk: string = '';
  action: any = {};

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    public dialog: MatDialog,
    public ngZone: NgZone,
    public destroyRef: DestroyRef,
    @Inject(MAT_DIALOG_DATA) public dialogdata: any,
    private _router: Router,

  ) { }

  ngOnInit(): void {

    this.title = this.dialogdata.title;
    this.message = this.dialogdata.message;
    this.isCancelNo=this.dialogdata.isCancelNo;
    this.viewAlert=this.dialogdata.viewAlert;
    this.yesContinue=this.dialogdata.yesContinue;
    this.isConfirm=this.dialogdata.isConfirm;
    this.displayNo = this.dialogdata.displayNo;
    this.isYesNo = this.dialogdata.isYesNo;
    this.showOrderView = this.dialogdata.orderView;
    this.isOk = this.dialogdata.isOk;
    this.action = {
      yes: { text: this.dialogdata.YES },
      no:  { text: this.dialogdata.NO  }
    };
  }


  onYesClick() {
      this.closeDialog(true);
  }

  onNoClick() {
    this.closeDialog(false);
  }

  onOKClick(){
    this.closeDialog(true);
  }

  closeDialog(status?: boolean) {
    this.ngZone.run(() => {
      this.dialogRef.close({data: status});
      requestAnimationFrame(() => {
        document
          .querySelectorAll('.cdk-overlay-backdrop')
          .forEach(el => el.remove());
      });
    });
  }

}
